module.exports = __webpack_public_path__ + "img/ssyx_23.bfa4fe28.jpg";